import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--spacing-x-small);

	&.horizontal {
		flex-direction: row;
		gap: var(--spacing-small);
	}

	.items {
		display: flex;
		flex-direction: inherit;
		gap: inherit;
	}
`;
